(function () {
  if (window.__molloInit) return;
  window.__molloInit = true;
  document.documentElement.classList.add('mo-anim');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EN = /^en/i.test(document.documentElement.lang || '');

  function countUp(el) {
    if (el.dataset.done) return;
    el.dataset.done = '1';
    var to = parseFloat(el.dataset.count) || 0, pre = el.dataset.prefix || '', suf = el.dataset.suffix || '', dec = parseInt(el.dataset.dec || '0', 10);
    function fmt(v) { var s = v.toFixed(dec); return pre + (EN ? s : s.replace('.', ',')) + suf; }
    if (reduce) { el.textContent = fmt(to); return; }
    var t0 = null, dur = 1400;
    function step(t) {
      if (!t0) t0 = t;
      var p = Math.min((t - t0) / dur, 1), e = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(dec ? to * e : Math.round(to * e));
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      en.target.classList.add('is-in');
      en.target.querySelectorAll('[data-count]').forEach(countUp);
      if (en.target.hasAttribute('data-count')) countUp(en.target);
      io.unobserve(en.target);
    });
  }, { threshold: 0.18, rootMargin: '0px 0px -40px 0px' }) : null;

  function init(root) {
    (root || document).querySelectorAll('.mo [data-reveal]:not(.is-in)').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('is-in');
    });
    // Rayon X : glisser pour voir l'intérieur
    (root || document).querySelectorAll('[data-xray]').forEach(function (x) {
      if (x.dataset.bound) return;
      x.dataset.bound = '1';
      var input = x.querySelector('input');
      function set(v, anim) {
        x.classList.toggle('is-anim', !!anim);
        x.style.setProperty('--x', v + '%');
        if (input) input.value = v;
        if (anim) setTimeout(function () { x.classList.remove('is-anim'); }, 1700);
      }
      x.__set = set;
      if (input) input.addEventListener('input', function () { set(input.value, false); });
      var done = false;
      function demo() { if (done) return; done = true; if (reduce) { set(62, false); return; } setTimeout(function () { set(62, true); }, 350); }
      if ('IntersectionObserver' in window) {
        var o = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { demo(); o.disconnect(); } }); }, { threshold: 0.4 });
        o.observe(x);
      } else demo();
    });
    // Survol des étapes -> mise en avant de la pièce dans la vue en coupe
    (root || document).querySelectorAll('.mo-sys').forEach(function (sec) {
      var fig = sec.querySelector('.mo-sys__fig');
      if (!fig || fig.dataset.bound) return;
      fig.dataset.bound = '1';
      sec.querySelectorAll('[data-part]').forEach(function (step) {
        var name = step.getAttribute('data-part');
        function on() { var xr = fig.querySelector('[data-xray]'); if (xr && xr.__set) xr.__set(92, true); fig.classList.add('has-focus'); fig.querySelectorAll('.mo-part').forEach(function (p) { p.classList.toggle('is-focus', p.getAttribute('data-p') === name); }); }
        function off() { fig.classList.remove('has-focus'); }
        step.addEventListener('mouseenter', on); step.addEventListener('mouseleave', off);
        step.addEventListener('focus', on); step.addEventListener('blur', off);
      });
    });
    // Produit phare : vignettes + pointures
    (root || document).querySelectorAll('.mo-spot').forEach(function (sp) {
      if (sp.dataset.bound) return; sp.dataset.bound = '1';
      var main = sp.querySelector('.mo-spot__main img');
      sp.querySelectorAll('.mo-spot__thumbs button').forEach(function (b) {
        b.addEventListener('click', function () {
          if (main) { main.removeAttribute('srcset'); main.src = b.dataset.src; }
          sp.querySelectorAll('.mo-spot__thumbs button').forEach(function (o) { o.setAttribute('aria-current', o === b ? 'true' : 'false'); });
        });
      });
      var hid = sp.querySelector('[data-mo-id]');
      sp.querySelectorAll('[data-mo-size]').forEach(function (r) {
        r.addEventListener('change', function () { if (hid) hid.value = r.value; });
      });
    });
    // Bandeau défilant : bouton pause (WCAG 2.2.2)
    (root || document).querySelectorAll('.mo-marquee__pause').forEach(function (b) {
      if (b.dataset.bound) return; b.dataset.bound = '1';
      b.addEventListener('click', function () {
        var m = b.closest('.mo-marquee'), p = m.classList.toggle('is-paused');
        b.setAttribute('aria-pressed', p ? 'true' : 'false');
        b.setAttribute('aria-label', EN ? (p ? 'Resume scrolling' : 'Pause scrolling') : (p ? 'Relancer le défilement' : 'Mettre en pause le défilement'));
      });
    });
    // Barre d'achat collante (mobile)
    (root || document).querySelectorAll('[data-mo-sticky]').forEach(function (bar) {
      if (bar.dataset.bound || !('IntersectionObserver' in window)) return; bar.dataset.bound = '1';
      var hero = document.querySelector('.mo-hero, .mo-h5'), form = document.querySelector('.mo-spot__form, .mo-spot'), foot = document.querySelector('.mo-foot');
      var st = { hero: true, form: false, foot: false };
      function upd() { bar.classList.toggle('is-on', !st.hero && !st.form && !st.foot); }
      var ob = new IntersectionObserver(function (es) { es.forEach(function (e) { st[e.target.__k] = e.isIntersecting; }); upd(); });
      [[hero, 'hero'], [form, 'form'], [foot, 'foot']].forEach(function (a) { if (a[0]) { a[0].__k = a[1]; ob.observe(a[0]); } });
    });
    var sys = document.querySelector('.mo-sys'); if (sys && !sys.id) sys.id = 'systeme';
    // Une seule question ouverte à la fois
    (root || document).querySelectorAll('.mo-faq').forEach(function (f) {
      f.querySelectorAll('details').forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (d.open) f.querySelectorAll('details[open]').forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
